import React, {ChangeEvent, useEffect, useState} from "react";
import {Button, Card, Form, ListGroup, Spinner, Modal} from "react-bootstrap";
import SignaturePad from "../../m4/predioPrograma/signaturePad";
import {CreateSubmissionDto, FormPayload, SubmissionNotes, SubmissionValue} from "../../../../service/types/types";
import {MultiValue} from "react-select";
import {useParams} from "react-router-dom";
import {FormsService} from "../../../../service/forms.service";
import {SubmissionsService} from "../../../../service/submission.service";
import {FileService} from "../../../../service/file.service";
import {UserBasicService} from "../../../../service/users-basic.service";

export default function DynamicFormRendererMail() {
    const [coords, setCoords] = useState<{ lat: number; lng: number } | null>(null);
    const [signature, setSignature] = useState<string>("");
    const [error, setError] = useState<string | null>(null);
    const [values, setValues] = useState<SubmissionValue[]>([]);
    const {id} = useParams<{ id: string }>();
    const [files, setFiles] = useState<File[]>([]);
    const [fileNameToPath, setFileNameToPath] = useState<Map<string, string>>(new Map());
    const [fileNameToFieldId, setFileNameToFieldId] = useState<Map<string, string>>(new Map());
    const [form, setForm] = useState<FormPayload | null>(null);
    const [loading, setLoading] = useState(false);
    const [notes, setNotes] = useState<SubmissionNotes[]>([]);

    //FIELD NOTES
    const [fieldId, setFieldId] = useState("");
    const [showModal, setShowModal] = useState<boolean>(false);
    const [noteFieldText, setNoteFieldText] = useState<string>("");
    const [noteFieldLocation, setNoteFieldLocation] = useState<{ lat: number; lng: number } | null>(null);
    const [noteFieldImage, setNoteFieldImage] = useState<File | null>(null);

    //FORM NOTES
    const [showNotesForm, setShowNotesForm] = useState(false);
    const [noteText, setNoteText] = useState<string>("");
    const [noteLocation, setNoteLocation] = useState<{ lat: number; lng: number } | null>(null);
    const [noteImage, setNoteImage] = useState<File | null>(null);

    const [mail, setMail] = useState<string>("");
    const [zonas, setZonas] = useState<string[]>([]);
    const [selectedZona, setSelectedZona] = useState<string>("");

    useEffect(() => {
        const fetchForm = async () => {
            if (!id) return;
            const data = await FormsService.findById(id);
            const zonas = await UserBasicService.findAllZona();
            setForm(data);
            setLoading(false);
            if (zonas) {
                setZonas(zonas);
            }
        };
        fetchForm();
    }, [id]);

    useEffect(() => {
        const valuesMap: Map<string, string> = new Map();

        fileNameToFieldId.forEach((fieldId, fileName) => {
            const path = fileNameToPath.get(fileName);
            if (path) {
                const existing = valuesMap.get(fieldId);
                if (existing) {
                    // si ya existe, concatenamos el nuevo path
                    valuesMap.set(fieldId, existing + ", " + path);
                } else {
                    valuesMap.set(fieldId, path);
                }
            }
        });

        // Convertir el Map a array de SubmissionValue
        const submissionValues: SubmissionValue[] = Array.from(valuesMap.entries()).map(
            ([fieldId, value]) => ({fieldId, value})
        );
        // Fusionar con el estado anterior
        setValues(prev => {
            const merged = new Map(prev.map(v => [v.fieldId, v.value]));

            submissionValues.forEach(({fieldId, value}) => {
                merged.set(fieldId, value); // override si existe
            });

            return Array.from(merged.entries()).map(([fieldId, value]) => ({fieldId, value}));
        });
    }, [fileNameToPath, fileNameToFieldId]);

    const handleDrawing = (fieldId: number, value: any) => {
        setSignature(value);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (showNotesForm) {
            alert("Por favor guarda o cierra el formulario de notas antes de enviar el formulario principal.");
            return;
        }
        if (id) {
            const submission: CreateSubmissionDto = {
                signature: signature,
                values: values,
                notes: notes,
                zona: selectedZona,
                mail: mail,
            };
            try {
                const data = await SubmissionsService.createWithCondition(id, submission);
                alert("Formulario enviado correctamente")
                // Reload the page
                window.location.reload();
            } catch (error) {
                console.error('Error submitting form:', error);
                alert("Error enviando formulario: " + (error as any)?.message || "Error desconocido");
            }
        }
    };
    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, fieldId: string) => {
        const input = e.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;

        // Solo tomar el primer archivo
        const file = input.files[0];

        // Remover archivo anterior del mismo fieldId si existe
        const previousFileName = Array.from(fileNameToFieldId.entries()).find(([_, fId]) => fId === fieldId)?.[0];
        if (previousFileName) {
            await handleRemoveFile(files.findIndex(f => f.name === previousFileName), files.find(f => f.name === previousFileName) as File);
        }

        setFiles((prev) => [...prev, file]);
        uploadFile(file, fieldId);
    };

    const uploadFile = async (file: File, fieldId: string) => {
        const formDataUpload = new FormData();
        formDataUpload.append("files", file);
        try {
            setLoading(true);
            const response = await FileService.upload(formDataUpload);
            setFileNameToPath(prev => {
                const newMap = new Map(prev);
                newMap.set(file.name, response.paths[0]);
                return newMap;
            });
            setFileNameToFieldId(prev => {
                const newMap = new Map(prev);
                newMap.set(file.name, fieldId);
                return newMap;
            });
            alert("Archivo subido correctamente");
        } catch (err) {
            alert("Error subiendo archivo: " + (err as any)?.message || "Error desconocido");
        } finally {
            setLoading(false);
        }
    }

    const handleRemoveFile = async (index: number, file: File) => {
        setFiles((prev) => prev.filter((_, i) => i !== index));
        try {
            let pathFile = fileNameToPath.get(file.name);
            pathFile = pathFile?.split("/").pop() || ""; // extraer solo el nombre del archivo
            const response = await FileService.remove(pathFile);
        } catch (err) {
            alert("Error eliminando archivo");
        }
        setFileNameToPath(prev => {
            const newMap = new Map(prev);
            newMap.delete(file.name);
            return newMap;
        });
        setFileNameToFieldId(prev => {
            const newMap = new Map(prev);
            newMap.delete(file.name);
            return newMap;
        });

    };

    const handleGetLocation = (fieldId: string) => {
        if (!navigator.geolocation) {
            alert("La geolocalización no está soportada en este navegador.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const cord = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                }
                setCoords(cord);
                handleChange(fieldId, JSON.stringify(cord));
                setError(null);
            },
            (err) => {
                alert("No se pudo obtener la ubicación: " + err.message);
            }
        );
    };
    const handleChange = (fieldId: string, value: any) => {
        setValues((prevValues) => {
            const existingIndex = prevValues.findIndex((v) => v.fieldId === fieldId);

            if (existingIndex !== -1) {
                // Ya existe → reemplazar el valor
                const updatedValues = [...prevValues];
                updatedValues[existingIndex] = {fieldId, value};
                return updatedValues;
            } else {
                // No existe → agregar nuevo
                return [...prevValues, {fieldId, value}];
            }
        });
    };
    const handleSelect = (fieldId: string, options: MultiValue<{ value: string; label: string }>) => {
        const value = options.map(opt => opt.label).join(", ");
        setValues((prevValues) => {
            const existingIndex = prevValues.findIndex((v) => v.fieldId === fieldId);

            if (existingIndex !== -1) {
                // Ya existe → reemplazar el valor
                const updatedValues = [...prevValues];
                updatedValues[existingIndex] = {fieldId, value};
                return updatedValues;
            } else {
                // No existe → agregar nuevo
                return [...prevValues, {fieldId, value}];
            }
        });
    };

    const handleNoteImageChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, isField = false) => {
        const input = e.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;
        if(isField){
            setNoteFieldImage(input.files[0]);
        } else {
            setNoteImage(input.files[0]);
        }
    };

    const uploadNoteImage = async (file: File): Promise<string> => {
        const formDataUpload = new FormData();
        formDataUpload.append("files", file);
        try {
            const response = await FileService.upload(formDataUpload);
            return response.paths[0];
        } catch (err) {
            alert("Error subiendo imagen de nota: " + (err as any)?.message || "Error desconocido");
            throw err;
        }
    };
    const handleNoteLocation = (isField = false) => {
        if (!navigator.geolocation) {
            alert("La geolocalización no está soportada en este navegador.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const cord = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                if(isField) {
                    setNoteFieldLocation(cord);
                }
                else {
                   setNoteLocation(cord);
                }
            },
            (err) => {
                const messages: Record<number, string> = {
                    1: "Permiso denegado por el usuario, habilite el permiso.",
                    2: "Posición no disponible.",
                    3: "Tiempo de espera agotado.",
                };
                alert("No se pudo obtener la ubicación: " + (messages[err.code] || err.message));
            },
            {
                enableHighAccuracy: true,  // force GPS, not cached cell/wifi
                timeout: 10000,            // fail after 10s instead of hanging
                maximumAge: 0,             // never use a cached position
            }
        );
    };

    const handleAddNote = async () => {
        if (!noteText.trim()) {
            alert("Por favor ingresa un texto para la nota");
            return;
        }

        try {
            setLoading(true);
            let imageUrl = "";
            let location = "";

            if (noteImage) {
                imageUrl = await uploadNoteImage(noteImage);
            }
            if (noteLocation) {
                location = JSON.stringify(noteLocation);
            }

            const newNote: SubmissionNotes = {
                noteText,
                imageUrl,
                location: location
            };

            setNotes((prevNotes) => [...prevNotes, newNote]);

            // Limpiar formulario
            setNoteText("");
            setNoteImage(null);
            setNoteFieldLocation(null);
            setShowNotesForm(false);

            alert("Nota añadida correctamente");
        } catch (err) {
            console.error('Error al agregar nota:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleAddFieldNote = async (fieldId: string) => {
        if (!noteFieldText.trim()) {
            alert("Por favor ingresa un texto para la nota");
            return;
        }

        try {
            setLoading(true);
            let imageUrl = "";
            let location = "";

            if (noteFieldImage) {
                imageUrl = await uploadNoteImage(noteFieldImage);
            }
            if (noteFieldLocation) {
                location = JSON.stringify(noteFieldLocation);
            }

            const newNote: SubmissionNotes = {
                noteText: noteFieldText,
                imageUrl,
                location: location
            };
            setValues((prevValues) => {
                const existingIndex = prevValues.findIndex((v) => v.fieldId === fieldId);
                const existingValues = prevValues.find(v => v.fieldId === fieldId)

                if (existingIndex !== -1) {
                    // Ya existe → reemplazar el valor
                    const updatedValues = [...prevValues];
                    updatedValues[existingIndex] = {fieldId, value: existingValues?.value ?? "", note: newNote};
                    return updatedValues;
                } else {
                    // No existe → agregar nuevo
                    return [...prevValues, {fieldId, value: "", note: newNote}];
                }
            });
            values.find(v => v.fieldId === fieldId)!.note = newNote;
            // Limpiar formulario
            setNoteFieldText("");
            setNoteFieldImage(null);
            setNoteFieldLocation(null);
            setFieldId("")
            setShowModal(false)

            alert("Nota añadida correctamente");
        } catch (err) {
            console.error('Error al agregar nota:', err);
        } finally {
            setLoading(false);
        }
    };
    const handleRemoveFieldNote = (fieldId: string) => {
        setValues((prevValues) => {
            const existingIndex = prevValues.findIndex((v) => v.fieldId === fieldId);
            const existingValues = prevValues.find(v => v.fieldId === fieldId)
            const updatedValues = [...prevValues];
            updatedValues[existingIndex] = {fieldId, value: existingValues?.value ?? "", note: undefined};
            return updatedValues;
        });
    };

    const handleRemoveNote = (index: number) => {
        setNotes((prevNotes) => prevNotes.filter((_, i) => i !== index));
    };

    return (
        <div className="w-100 p-4">
            <h2 className="mb-4">{form?.name}</h2>
            <Form onSubmit={handleSubmit} className="w-100">
                {zonas.length > 1 &&
                    <Form.Group className="mb-3">
                        <Form.Label>Seleccione Zona</Form.Label>
                        <Form.Select
                            value={selectedZona}
                            required={true}
                            onChange={(e) => setSelectedZona(e.target.value)}
                            className="w-100"
                        >
                            <option value="">Seleccione una lista...</option>
                            {zonas.map(zona => (
                                <option key={zona} value={zona}>
                                    {zona}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                }
                <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Ingrese Su Correo</Form.Label>
                    <Form.Control
                        type="email"
                        required={true}
                        placeholder="ingrese email"
                        value={mail}
                        onChange={(e) => setMail(e.target.value)}
                    />
                </Form.Group>
                {form?.fields.map(field => (
                    <Form.Group key={field.id} className="mb-3 w-100">
                        <Form.Label>
                            {field.label} {field.required && "*"}
                        </Form.Label>

                        {field.type === "text" && (
                            <Form.Control
                                type="text"
                                required={field.required}
                                className="w-100"
                                onChange={e => handleChange(field.id, e.target.value)}
                            />
                        )}

                        {field.type === "number" && (
                            <Form.Control
                                type="number"
                                required={field.required}
                                className="w-100"
                                onChange={e => handleChange(field.id, e.target.value)}
                            />
                        )}

                        {field.type === "date" && (
                            <Form.Control
                                type="datetime-local"
                                required={field.required}
                                className="w-100"
                                onChange={e => handleChange(field.id, e.target.value)}
                            />
                        )}

                        {field.type === "files" && (
                            <Form.Control
                                type="file"
                                accept="image/*"        // acepta imágenes
                                onChange={(e) => handleFileChange(e, field.id)}
                            />
                        )}

                        {field.type === "select" && (
                            <Form.Select
                                required={field.required}
                                className="w-100"
                                onChange={e => handleChange(field.id, e.target.value)}
                            >
                                <option value="">Seleccione...</option>
                                {field.options?.map(opt => (
                                    <option key={opt} value={opt}>
                                        {opt}
                                    </option>
                                ))}
                            </Form.Select>
                        )}
                        {field.type === "location" && (
                            <div className="d-flex">
                                <Form.Control
                                    type="text"
                                    readOnly
                                    value={
                                        coords
                                            ? `Lat: ${coords.lat}, Lng: ${coords.lng}`
                                            : "Presiona el botón para obtener ubicación"
                                    }
                                />
                                <Button
                                    variant="primary"
                                    className="ms-2"
                                    onClick={e => handleGetLocation(field.id)}
                                >
                                    Obtener
                                </Button>
                            </div>
                        )}
                        {field.sendMail && values.find(v => v.fieldId === field.id)?.value?.toUpperCase().trim() === field.sendMailCondition?.toUpperCase().trim() && values.find(v => v.fieldId === field.id)?.note === undefined && (
                            <button onClick={() => {
                                setFieldId(field.id);
                                setShowModal(true);
                            }} type="button" className="btn btn-outline-secondary mt-2">
                                + Añadir Nota Para Este Campo
                            </button>
                        )}
                        {values.find(v => v.fieldId === field.id)?.note && (
                            <ListGroup>
                                <br/>
                                <ListGroup.Item key={field.id} className="mb-2">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div className="flex-grow-1">
                                            <p className="mb-2"><strong>Nota campo: {field.label}</strong></p>
                                            <p className="mb-2">{values?.find(v => v.fieldId === field.id)?.note?.noteText}</p>
                                            {values?.find(v => v.fieldId === field.id)?.note?.imageUrl && (
                                                <div className="mb-2">
                                                    <img
                                                        src={"/api" + values?.find(v => v.fieldId === field.id)?.note?.imageUrl}
                                                        style={{
                                                            maxWidth: "200px",
                                                            maxHeight: "200px",
                                                            borderRadius: "4px"
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => handleRemoveFieldNote(field.id) }
                                        >
                                            Eliminar
                                        </Button>
                                    </div>
                                </ListGroup.Item>
                            </ListGroup>
                        )}
                            </Form.Group>
                ))}


                {/* Sección de Notas */}
                <div className="mb-4">
                    {showNotesForm ? (
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowNotesForm(!showNotesForm)}
                                className="mb-3 w-100"
                            >
                                Ocultar Formulario de Notas
                            </Button>) :
                        (<Button
                            variant="outline-success"
                            onClick={() => setShowNotesForm(!showNotesForm)}
                            className="mb-3 w-100"
                        >
                            + Añadir Nota Para Este Formualário
                        </Button>)
                    }
                    {showNotesForm && (
                        <Card className="mb-3 p-3">
                            <Form.Group className="mb-3">
                                <Form.Label>Texto de la Nota</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                    placeholder="Escribe tu nota aquí..."
                                    className="w-100"
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <div className="d-flex">
                                    <Form.Control
                                        type="text"
                                        readOnly
                                        value={
                                            noteLocation
                                                ? `Lat: ${noteLocation.lat}, Lng: ${noteLocation.lng}`
                                                : "Presiona el botón para obtener ubicación (Opcional)"
                                        }
                                    />
                                    <Button
                                        variant="primary"
                                        className="ms-2"
                                        onClick={e => handleNoteLocation(false)}
                                    >
                                        Obtener
                                    </Button>
                                </div>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Imagen (Opcional)</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    onChange={handleNoteImageChange}
                                    className="w-100"
                                />
                                {noteImage && (
                                    <div className="mt-2">
                                        <small className="text-muted">Archivo seleccionado: {noteImage.name}</small>
                                    </div>
                                )}
                            </Form.Group>

                            <Button
                                variant="success"
                                onClick={handleAddNote}
                                disabled={loading}
                                className="w-100"
                            >
                                {loading ? "Guardando..." : "Guardar Nota"}
                            </Button>
                        </Card>
                    )}

                    {notes.length > 0 && (
                        <div className="mb-4">
                            <h5>Notas Agregadas ({notes.length})</h5>
                            <ListGroup>
                                {notes.map((note, index) => (
                                    <ListGroup.Item key={index} className="mb-2">
                                        <div className="d-flex justify-content-between align-items-start">
                                            <div className="flex-grow-1">
                                                <p className="mb-2"><strong>Nota {index + 1}:</strong></p>
                                                <p className="mb-2">{note.noteText}</p>
                                                {note.imageUrl && (
                                                    <div className="mb-2">
                                                        <img
                                                            src={"/api" + note.imageUrl}
                                                            alt={`Nota ${index + 1}`}
                                                            style={{
                                                                maxWidth: "200px",
                                                                maxHeight: "200px",
                                                                borderRadius: "4px"
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                onClick={() => handleRemoveNote(index)}
                                            >
                                                Eliminar
                                            </Button>
                                        </div>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </div>
                    )}
                </div>
                {/* Campo de firma/dibujo */}
                {form?.isSignRequired &&
                    <Form.Group className="mb-3 w-100">
                        <Form.Label>Dibujo / Firma</Form.Label>
                        <SignaturePad onChange={dataUrl => handleDrawing(-1, dataUrl)}/>
                    </Form.Group>
                }

                <Button variant="primary" type="submit" className="w-100">
                    Enviar
                </Button>
            </Form>
            {/* Overlay cuando loading es true */}
            {loading && (
                <div
                    className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{
                        backgroundColor: 'rgba(255,255,255,0.7)', // fondo más claro
                        zIndex: 9999,
                    }}
                >
                    <Spinner animation="border" role="status"/>
                    {/* O puedes usar una imagen personalizada */}
                    {/* <img src="/loading.gif" alt="Cargando..." /> */}
                </div>
            )}
            <Modal show={showModal} onHide={()=> setShowModal(false) } centered>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Nota</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={noteFieldText}
                            onChange={(e) => setNoteFieldText(e.target.value)}
                            placeholder="Escribe tu nota aquí..."
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <div className="d-flex">
                            <Form.Control
                                type="text"
                                readOnly
                                value={
                                    noteFieldLocation
                                        ? `Lat: ${noteFieldLocation.lat}, Lng: ${noteFieldLocation.lng}`
                                        : "Presiona el botón para obtener ubicación (Opcional)"
                                }
                            />
                            <Button
                                variant="primary"
                                className="ms-2"
                                onClick={() => handleNoteLocation(true)}
                            >
                                Obtener
                            </Button>
                        </div>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleNoteImageChange(e, true)}
                        />
                        {noteFieldImage && (
                            <small className="text-muted mt-2 d-block">
                                Archivo seleccionado: {noteFieldImage.name}
                            </small>
                        )}
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={()=> setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant="success"
                        onClick={() => handleAddFieldNote(fieldId)}
                        disabled={loading}
                    >
                        {loading ? "Guardando..." : "Guardar Nota"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}